import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import "./assets/styles/_main.scss";
import Lottie from "vue-lottie";
import Modal from "@/components/widgets/modals/manyAttemps";

import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";

import 'vuetify/dist/vuetify.min.css'
// node_modules\vuetify\dist\vuetify.min.css

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "mdi",
});

Vue.use(VueMask);
Vue.use(Modal);

Vue.component("vue2-lottie", Lottie);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
